<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area">
      <img :src="`${resources}img/img-top-sub-title21.jpg`" alt="" />
      <div class="tit_area">
        <div class="sub_tit">시행사업</div>
        <div class="sub_txt">
          고객의 라이프 스타일에 맞는 문화를 만들어 갑니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="techSlide1 tech_slide02" ref="techSwiperRef">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_01.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_02.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_03.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_04.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_05.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
          <div class="swiper-slide">
            <img
              :src="`${resources}img/tech_slide05_06.png`"
              class="swiper-lazy"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <div class="tech-paging tech-pagination1"></div>
      </div>
      <h3>시행사업 절차</h3>
      <ul class="factory_info4">
        <li class="div_color01">
          <p class="txt_step">STEP 01</p>
          <p class="tit_info3"><strong>사업지 파악 및 사업성검토</strong></p>
          <ul>
            <li>시행사업 입지 분석</li>
            <li>사업타당성 검토</li>
          </ul>
        </li>
        <li class="div_color02">
          <p class="txt_step">STEP 02</p>
          <p class="tit_info3"><strong>자금조달 및 토지 계약</strong></p>
          <ul>
            <li>금융기관&middot;시공사 등과 PF 협의</li>
            <li>토지 계약 및 계약금 진행</li>
          </ul>
        </li>
        <li class="div_color03">
          <p class="txt_step">STEP 03</p>
          <p class="tit_info3"><strong>시공사 선정 및 인허가 진행</strong></p>
          <ul>
            <li>시공 및 금융담보 제공할 건설사 선정</li>
            <li>건축심의 사업승인(건축허가)신청</li>
          </ul>
        </li>
        <li class="div_color04">
          <p class="txt_step">STEP 04</p>
          <p class="tit_info3">
            <strong>프로젝트파이낸싱(PF) 대출<br />및 토지 비용 납부</strong>
          </p>
          <ul>
            <li>PF 대출 및 대출 진행</li>
            <li>확보 자금으로 토지 비용 납부</li>
          </ul>
        </li>
        <li class="div_color05">
          <p class="txt_step">STEP 05</p>
          <p class="tit_info3"><strong>착공 및 분양</strong></p>
          <ul>
            <li>건축물 공사 시작</li>
            <li>분양관련 업무 수행 및 분양 실행</li>
          </ul>
        </li>
        <li class="div_color06">
          <p class="txt_step">STEP 06</p>
          <p class="tit_info3"><strong>공사관리 및 준공 후 사후관리</strong></p>
          <ul>
            <li>사용승인까지 공사관리</li>
            <li>준공 및 입주 후 관리</li>
          </ul>
        </li>
      </ul>
      <div class="tbl_ty01 bod align_td_cnt mgt40 tbl_scroll">
        <table>
          <caption>
            시행사업
          </caption>
          <colgroup>
            <col style="width: 25%" />
            <col style="width: 35%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <th scope="row">시공사</th>
            <th scope="row">현장명</th>
            <th scope="row">연 도</th>
            <th scope="row">시행실적<br />(단위:억원)</th>
          </thead>
          <tbody>
            <tr>
              <td>GS건설</td>
              <td>고양덕은 DMC한강자이더헤리티지</td>
              <td>2020</td>
              <td>4,282</td>
            </tr>
            <tr>
              <td>대우건설㈜</td>
              <td>판교 푸르지오그랑블 아파트</td>
              <td>2008</td>
              <td>3,400</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import Swiper from 'swiper';
import page from '@/mixins/page';

export default {
  mixins: [page],
  mounted() {
    // 시행사업
    new Swiper(this.$refs.techSwiperRef, {
      loop         : true,
      slidesPerView: 'auto',
      spaceBetween : 10,
      pagination   : {
        el: '.tech-pagination1'
      },
      lazy: {
        loadPrevNext: true
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.techSlide1 {
  .swiper-wrapper .swiper-slide {
    min-height: calc((100vw - 40rem) * 0.54);
    background-color: #f1f1f1;
  }
}
</style>
